import PropTypes from 'prop-types';

const AccountError = ({ touched, errors, accountSetIndex, accountIndex }) => {
  const showError =
    touched?.accountSets?.length > 0 &&
    touched.accountSets[accountSetIndex] &&
    errors?.accountSets?.length > 0 &&
    typeof errors.accountSets[accountSetIndex] === 'object' &&
    errors.accountSets[accountSetIndex].length > 0 &&
    errors.accountSets[accountSetIndex][accountIndex];

  if (showError) {
    return (
      <tr className="gl-accountset-error">
        <td colSpan={7}>{showError}</td>
      </tr>
    );
  }
  return null;
};

AccountError.propTypes = {
  accountSetIndex: PropTypes.number.isRequired,
  accountIndex: PropTypes.number.isRequired,
  touched: PropTypes.objectOf(PropTypes.any).isRequired,
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default AccountError;
